import { useState } from 'react';
import { Link } from 'react-router-dom';
import { Wrench, Search, Home, Menu, ShoppingCart } from 'lucide-react';
import { cn } from '../lib/utils';
import {
  Drawer,
  DrawerContent,
  DrawerTrigger,
} from './ui/drawer';
import GarageDrawer from './GarageDrawer';
import SearchDrawer from './SearchDrawer';
import MenuDrawer from './MenuDrawer';
import CartDrawer from './CartDrawer';

const navItems = [
  { icon: Wrench, label: 'Garage', key: 'garage' },
  { icon: Search, label: 'Search', key: 'search' },
  { icon: Home, label: 'Home', key: 'home' },
  { icon: Menu, label: 'Menu', key: 'menu' },
  { icon: ShoppingCart, label: 'Cart', key: 'cart' },
];

export default function BottomNav() {
  const handleHomeClick = (e) => {
    e.preventDefault();
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <nav className="fixed bottom-0 left-0 right-0 z-50 md:hidden border-t border-border bg-background">
      <div className="flex items-center justify-around py-2">
        {navItems.map(({ icon: Icon, label, key }) => {
          if (key === 'home') {
            return (
              <Link
                key={key}
                to="/"
                onClick={handleHomeClick}
                className="flex flex-col items-center gap-1 px-3 py-1"
              >
                <Icon className="h-5 w-5 text-foreground" />
                <span className="text-[10px] text-foreground font-medium">{label}</span>
              </Link>
            );
          }

          return (
            <BottomNavDrawer key={key} icon={Icon} label={label} drawerKey={key} />
          );
        })}
      </div>
    </nav>
  );
}

function BottomNavDrawer({ icon: Icon, label, drawerKey }) {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <Drawer open={isOpen} onOpenChange={setIsOpen}>
      <DrawerTrigger asChild>
        <button className="flex flex-col items-center gap-1 px-3 py-1">
          <Icon className={cn(
            "h-5 w-5",
            isOpen ? "text-brand-red" : "text-foreground"
          )} />
          <span className={cn(
            "text-[10px] font-medium",
            isOpen ? "text-brand-red" : "text-foreground"
          )}>
            {label}
          </span>
        </button>
      </DrawerTrigger>
      <DrawerContent className="max-h-[75vh]">
        {drawerKey === 'garage' && <GarageDrawer onClose={() => setIsOpen(false)} />}
        {drawerKey === 'search' && <SearchDrawer onClose={() => setIsOpen(false)} />}
        {drawerKey === 'menu' && <MenuDrawer onClose={() => setIsOpen(false)} />}
        {drawerKey === 'cart' && <CartDrawer onClose={() => setIsOpen(false)} />}
      </DrawerContent>
    </Drawer>
  );
}